export const checkStatus = res => {
  if (res.status >= 200 && res.status < 300) {
    return res
  } else {
    throw new Error(`${res.status}: ${res.statusText}`)
  }
}